import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ContainerForm } from '@/components/Form/ContainerForm'
import { useUser } from '@/context/UserProvider'
import { createNewProduct, updateProduct } from '@/store/products/actions'
import { yupResolver } from '@hookform/resolvers/yup'

import { formDefaultValues } from './formConfig'
import { FormContent } from './formContent'
import { formValidationSchema } from './formValidation'

import s from './styles.module.scss'

const FormCreateNewPlanPrices = ({ formValues, onClose }) => {
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(false)
  const { defaultCentre } = useUser()

  const handleSubmit = (data) => {
    setIsLoading(true)
    const auxData = {
      ...data,
      centre: defaultCentre,
    }

    try {
      if (formValues) {
        dispatch(updateProduct(auxData))
      } else {
        dispatch(createNewProduct(auxData))
      }
      onClose()
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <ContainerForm
        className={s.containerForm}
        onSubmit={(data) => handleSubmit(data)}
        defaultValues={{ ...formDefaultValues, ...formValues }}
        resolver={yupResolver(formValidationSchema)}
      >
        <FormContent isLoading={isLoading} onClose={onClose} />
      </ContainerForm>
    </div>
  )
}

export default FormCreateNewPlanPrices
